import React from "react";
import "./style.css";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Container, Row, Col, Tabs, Tab } from "react-bootstrap";
import { dataportfolio, dataweb3, meta } from "../../content_option";

export const Portfolio = () => {
  const renderProjects = (projects) => (
    <div className="portfolio-grid mb-5">
      {projects.map((data, i) => (
        <a
          key={i}
          href={data.link}
          className="project-card-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="project-card">
            <img
              src={data.img || "/assets/projectImages/placeholder.png"}
              alt={`project-${i}`}
              loading="lazy"
              className="project-image"
            />
            <div className="project-details">
              <h3 className="project-title">{data.title}</h3>
              <p className="project-description">{data.description}</p>
              {data.tags && (
                <div className="project-tags">
                  {data.tags.map((tag, idx) => (
                    <span key={idx} className="project-tag">#{tag}</span>
                  ))}
                </div>
              )}
            </div>
          </div>
        </a>
      ))}
    </div>
  );

  // 🔹 Web3 projects GitHub-style list
  const renderWeb3Projects = (projects) => (
    <div className="web3-project-list mb-5">
      {projects.map((data, i) => (
        <a
          key={i}
          href={data.link}
          className="web3-project-card"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="web3-project-content">  
            <div className="web3-project-avatar">
              <img
                src="/assets/projectImages/gojo.png" 
                alt="avatar"
              />  
            </div>
            <div className="web3-project-info">
              <h3 className="web3-project-title">{data.title}</h3>
              <p className="web3-project-meta">
                {data.author || "YourGitHub"} • Updated {data.updated}
              </p>
            </div>
          </div>
        </a>
      ))}
    </div>
  );

  return (
    <HelmetProvider>
      <Container className="Portfolio-section">
        <Helmet>
          <meta charSet="utf-8" />
          <title>Projects | {meta.title}</title>
          <meta name="description" content={meta.description} />
        </Helmet>

        <Row className="mt-1 pt-md-3">
          <Col lg="8">
            <h1 className="display-4 mb-4">Projects</h1>
            <hr className="t_border my-4 ml-0 text-left" />
          </Col>
        </Row>

        {/* Tabbed Layout */}
        <Tabs defaultActiveKey="general" id="portfolio-tabs" className="mb-4">
          <Tab eventKey="general" title="Web2">
            {renderProjects(dataportfolio)}
          </Tab>
          <Tab eventKey="web3" title="Web3">
            {renderWeb3Projects(dataweb3)}
          </Tab>
        </Tabs>
      </Container>
    </HelmetProvider>
  );
};
